import React from "react";
import { toast } from "sonner";
import { ShieldCheck, Download, EyeOff } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const HrRgpd = ({ emp, onChanged }) => {
  const { user } = useAuth();
  const canExport = ["owner", "hr"].includes(user?.role);
  const isOwner = user?.role === "owner";

  const exportData = async () => {
    try {
      const r = await api.get(`/hr/employees/${emp.id}/rgpd-export`);
      const blob = new Blob([JSON.stringify(r.data, null, 2)], { type: "application/json" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob); a.download = `donnees-rgpd-${(emp.name || "salarie").replace(/\s+/g, "-")}.json`; a.click();
      toast.success("Export RGPD généré");
    } catch (e) { toast.error(apiErr(e)); }
  };
  const anonymize = async () => {
    if (!window.confirm("Anonymiser définitivement ce salarié ? Ses coordonnées personnelles et documents seront supprimés. Action irréversible.")) return;
    try { await api.post(`/hr/employees/${emp.id}/anonymize`); toast.success("Salarié anonymisé"); onChanged && onChanged(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div className="mt-3 space-y-3 text-sm" data-testid="rh-rgpd">
      <div className="flex items-start gap-2 rounded-2xl bg-emerald-50 p-3 text-emerald-800">
        <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0" />
        <p>Données traitées pour la gestion du personnel (obligation légale et exécution du contrat). Conservation : 5 ans après la sortie du salarié. Chaque consultation de document et chaque export sont tracés dans le journal RH.</p>
      </div>
      {canExport ? (
        <Button data-testid="rh-rgpd-export" onClick={exportData} variant="outline" className="w-full rounded-full"><Download className="mr-1 h-4 w-4" />Exporter les données du salarié (droit d'accès)</Button>
      ) : <p className="text-xs text-gray-400">L'export RGPD est réservé au propriétaire et au rôle RH.</p>}
      {isOwner && (
        <Button data-testid="rh-rgpd-anonymize" onClick={anonymize} disabled={emp.hr_status !== "sorti" || emp.anonymized} variant="outline" className="w-full rounded-full border-rose-200 text-rose-600 hover:bg-rose-50">
          <EyeOff className="mr-1 h-4 w-4" />{emp.anonymized ? "Déjà anonymisé" : "Anonymiser (salarié sorti uniquement)"}
        </Button>
      )}
    </div>
  );
};
